import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { AddendumServicesResponse } from '../../models/addendum.model';
import { ContractPayment, ContractPaymentResponse } from '../../models/contractPayment.model';
import { ContractSession, ContractSessionListResponse } from '../../models/contractsession.model';
import { ConfigDocuments, ConfigDocumentsResponse, ContractsAzureDetailsResponse, GenerateContractsAzure, PrintDocAzure } from '../../models/document.model';
import { Navigation, NavigationResponse } from '../../models/navigation.model';
import { ProductDetails, ProductListResponse, ProductResponse } from '../../models/product.model';
import { State } from '../../models/state.model';
import { UserResponse } from '../../models/user.model';
import { AddendumService } from '../../services/addendum.service';
import { BillingService } from '../../services/billing.service';
import { ContractSessionService } from '../../services/contractsession.service';
import { DocumentService } from '../../services/document.service';
import { NavigationService } from '../../services/navigation.service';
import { ProductService } from '../../services/product.service';
import { UtilityService } from '../../services/shared/utility.service';
import { StateService } from '../../services/state.service';
import { UserService } from '../../services/user.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-client-export-to-pdf',
    templateUrl: './client-export-to-pdf.component.html',
    styleUrls: ['./client-export-to-pdf.component.css']
})
/** client-export-to-pdf component*/
export class ClientExportToPdfComponent implements OnInit {
    stateList: State[];
    //productDetail: ProductDetails;
    //contractSession: ContractSession;
    //private contractPayment: ContractPayment;
    //private addendumServicesResponse: AddendumServicesResponse;
    contractSessionListResponse: ContractSessionListResponse;
    userResponse: UserResponse;
    //private navigationResponse: NavigationResponse;
    //ContractPaymentResponse: ContractPaymentResponse;
    configDocumentsResponse: ConfigDocumentsResponse;
    productListResponse: ProductListResponse;
    gencontractDetailsResponse: ContractsAzureDetailsResponse;
    generateContractsAzure: GenerateContractsAzure[];
    encryptedUser: string = '';
    //contractSessionId: number = 0;
    isSecondContract: boolean = false;
    isROISubmitted: boolean = false;
    private navigation: Navigation;
    productResponse: ProductResponse;
    productDetails: ProductDetails[];
    configDocuments: ConfigDocuments;
    printDocidAzure: PrintDocAzure[];
    //flgInstallment: boolean = false;
    //productId: number = 0;
    finaldocument: string;
    filterUserStateLst: State[];
    isWaitingPeriod: boolean = false;
    isWaitStateDoc: boolean = false;
    isWaitStateExists: boolean = false;
    isWestern: boolean = false;
    isStateExists: boolean = false;
    dvSpinner: boolean = false;
    /** client-export-to-pdf ctor */
    constructor(private _route: ActivatedRoute,
        private _userService: UserService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _navigationService: NavigationService,
        private _billingService: BillingService,
        private _productService: ProductService,
        private _documentService: DocumentService,
        private _stateService: StateService,
        private _addendumService: AddendumService,
        private _contractSessionService: ContractSessionService) {
    }
    ngOnInit(): void {
        this.fetchStateList();
    }
    //exportToPDF(inventionId, contractSessionId, isSecondContract, productId, countryID, clientState,
    //    USFeeConfirm, isNDADoc, isPayCollectForm, isROIForm, eIHFullPaymentDoc, eIWHFullPaymentDoc, eIHInstallPaymentDoc, eIWHInstallPaymentDoc, ihMandatoryDoc) {
    //    this.loadNavigationWizard(inventionId, contractSessionId).subscribe((value) => this.loadProduct(productId, countryID)
    //        .subscribe((value) => this.ContractPaymentGet(inventionId, productId, contractSessionId)
    //            .subscribe((value) => this.loadAddendumServices(inventionId, contractSessionId)
    //                .subscribe((value) => this.printDocIDS(inventionId, contractSessionId, isSecondContract, productId, countryID, clientState, USFeeConfirm,
    //                    isNDADoc, isPayCollectForm, isROIForm, eIHFullPaymentDoc, eIWHFullPaymentDoc, eIHInstallPaymentDoc, eIWHInstallPaymentDoc, ihMandatoryDoc)
    //                ))));
    //}

    async GetGenerateContractDetailsAll() {
        $('#ClientmodalExporttoPDF').modal('show');
        this.dvSpinner = true;
        await this._documentService.getContractsAzureDetailsAllAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);
                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);
                    for (var csess in this.generateContractsAzure) {
                        this.printDocIDS(this.generateContractsAzure[csess].inventionId, this.generateContractsAzure[csess].contractSessionId,
                            this.generateContractsAzure[csess].isSecondContract, this.generateContractsAzure[csess].productId, this.generateContractsAzure[csess].countryID,
                            this.generateContractsAzure[csess].clientState, this.generateContractsAzure[csess].USFeeConfirm, this.generateContractsAzure[csess].isNDADoc,
                            this.generateContractsAzure[csess].isPayCollectForm, this.generateContractsAzure[csess].isROIForm, this.generateContractsAzure[csess].eIHFullPaymentDoc, this.generateContractsAzure[csess].eIWHFullPaymentDoc,
                            this.generateContractsAzure[csess].eIHInstallPaymentDoc, this.generateContractsAzure[csess].eIWHInstallPaymentDoc, this.generateContractsAzure[csess].ihMandatoryDoc,
                            this.generateContractsAzure[csess].paymentOptionId, this.generateContractsAzure[csess].isNoService, this.generateContractsAzure[csess].isAddendumB,
                            this.generateContractsAzure[csess].isAddendumG, this.generateContractsAzure[csess].isAddendumP, this.generateContractsAzure[csess].isPatentServices)
                    }
                    this.updateGenerateContractsIDSAsync();
                }

            })
            .catch((err: HttpErrorResponse) => {
                $('#ClientmodalExporttoPDF').modal('hide');
                this.dvSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
    updateGenerateContractsIDSAsync() {
        this._documentService.updateGenerateContractsAzureIDSAsync(this.encryptedUser, this.printDocidAzure)
            .then(res => {
                if (res) {
                    if (res.statusCode == '0') {
                        $('#ClientmodalExporttoPDF').modal('hide');
                        this.dvSpinner = false;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                $('#ClientmodalExporttoPDF').modal('hide');
                this.dvSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    checkExistState(StateId) {
        switch (StateId) {
            case 24: this.isStateExists = true;
                break;
            case 26: this.isStateExists = true;
                break;
            case 34: this.isStateExists = true;
                break;
            case 35: this.isStateExists = true;
                break;
            case 37: this.isStateExists = true;
                break;
            case 44: this.isStateExists = true;
                break;
            case 47: this.isStateExists = true;
                break;
            default: this.isStateExists = false;
                break;
        }

    }

    private async loadDocumentType() {
        await this._documentService.getConfigDetailsAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.configDocumentsResponse = UtilityService.clone(res);
                        if (this.configDocumentsResponse) {
                            this.configDocuments = this.configDocumentsResponse.configDocuments;
                            this.GetGenerateContractDetailsAll();
                        }
                    }
                }
            })
    }

    private async fetchStateList() {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.stateList = UtilityService.clone(result);
                this.loadDocumentType();
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private loadNavigationWizard(inventionId, contractSessionId) {
        return new Observable(observer => {
            this._navigationService.getNavigationWizardAsync(this.encryptedUser, inventionId, contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            //this.navigationResponse = UtilityService.clone(res);
                            //this.navigation = this.navigationResponse.navigation;
                            observer.next("success");
                        } else {
                            console.log("Navigation Wizard result status code: " + res.statusCode);
                        }
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        });
    }
    private loadProduct(productId, countryID) {
        return new Observable(observer => {
            this._productService.getProductAsync(this.encryptedUser, productId, countryID, productId >= 9 ? "Plus" : "Normal")
                .then(async (result: ProductResponse) => {
                    if (result) {
                        this.productResponse = UtilityService.clone(result);
                        if (this.productResponse) {
                            //this.productDetail = UtilityService.clone(this.productResponse.productDetails);
                            //this.productId = this.productDetail.productId;
                            observer.next("success");
                        } else {
                            console.log("Product result status code: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        });
    }

    private ContractPaymentGet(inventionId, productId, ContractSessionId) {
        return new Observable(observer => {
            this._billingService.getContractPaymentAsync(this.encryptedUser, inventionId, productId, ContractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            //this.ContractPaymentResponse = UtilityService.clone(res);
                            //this.contractPayment = this.ContractPaymentResponse.contractPayment;
                            //if (this.contractPayment.paymentOptionId == 1)
                            //this.flgInstallment = false;
                            //lse
                            //this.flgInstallment = true;
                            observer.next("success");
                            //this.exportSetValue(inventionId, contractStatus);

                        } else {
                            console.log("Office List result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        });
        //callback();
    }
    private loadAddendumServices(inventionId, contractSessionId) {
        return new Observable(observer => {
            this._addendumService.AddendumServices_GetAsync(this.encryptedUser, inventionId, contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            //this.addendumServicesResponse = UtilityService.clone(res);
                            observer.next("success");
                        } else {
                            console.log("Addendum services result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        });
    }


    printDocIDS(inventionId, contractSessionId, isSecondContract, productId, countryID, clientState, USFeeConfirm,
        isNDADoc, isPayCollectForm, isROIForm, eIHFullPaymentDoc, eIWHFullPaymentDoc, eIHInstallPaymentDoc, eIWHInstallPaymentDoc,
        ihMandatoryDoc, paymentOptionId, isNoService, isAddendumB, isAddendumG, isAddendumP, isPatentServices) {
        let docIds: string = "";
        this.isSecondContract = isSecondContract;
        var state = this.stateList.find(st => st.code.toLowerCase() == clientState.toLowerCase());
        this.isWestern = countryID == 1 ? state.isWestern : false;
        this.isStateExists = state.isSpecial;
        let stateid: number = state != null ? state.id : -1;
        //this.checkExistState(stateid);
        if (paymentOptionId == 1 || paymentOptionId == 0)
            docIds += this.isWestern == false ? eIHFullPaymentDoc : eIWHFullPaymentDoc;
        else if (paymentOptionId == 2)
            docIds += this.isWestern == false ? eIHInstallPaymentDoc : eIWHInstallPaymentDoc;

        if (productId == 1 || productId == 2 || productId == 6) {

            if (!isNDADoc && countryID < 3) {
                docIds = ihMandatoryDoc.replace("S", "0");
            }
            else {
                if (!isNullOrUndefined(this.configDocuments)) {
                    var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                    var sateDocBeforeAfterNDA_bip = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 5));
                }
                if (!isNullOrUndefined(state) && state.code == "KS" && countryID == 1 && sateDocBeforeAfterNDA_bip)
                    docIds = docIds.replace("AD", sateDocBeforeAfterNDA_bip.id.toString());
                else if (sateDocBeforeAfterNDA && sateDocBeforeAfterNDA_bip)
                    docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString() + "," + sateDocBeforeAfterNDA_bip.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }

            if (USFeeConfirm == 2) {
                docIds = this.isWestern == true ? docIds.replace("32", "37") : docIds.replace("22", "37");
                docIds = docIds.replace(",3,", ",38,");
            }
        }
        else if (productId == 3 || productId == 7) {
            var submissionAgreementDoc = countryID > 2 ? (this.configDocuments.docsList.find(i => i.id == 131 && i.agreement == false && i.docType == -1))
                : (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == -1));
            submissionAgreementDoc = submissionAgreementDoc != null ? submissionAgreementDoc :
                (this.configDocuments.docsList.find(i => i.id == 66 && i.agreement == false && i.docType == -1));

            if (submissionAgreementDoc)
                docIds = docIds.replace("SA", submissionAgreementDoc.id.toString());
            else
                docIds = docIds.replace(",SA", "");

            if (isNoService) {
                docIds = docIds.replace("82,", "").replace("83,", "").replace("84,", "").replace("85,", "").replace("86,", "").replace("87,", "").replace("88,", "").replace("89,", "");
            }
            else {
                if (!isAddendumB)
                    docIds = this.isWestern ? docIds.replace("89,", "") : docIds.replace("88,", "");

                if (!isAddendumG)
                    docIds = this.isWestern ? docIds.replace("87,", "") : docIds.replace("86,", "");

                if (!isAddendumP)
                    docIds = this.isWestern ? docIds.replace("85,", "") : docIds.replace("84,", "");

                if (!isPatentServices)
                    docIds = this.isWestern ? docIds.replace("83,", "") : docIds.replace("82,", "");
            }
            if (!isNullOrUndefined(this.configDocuments)) {
                var sateDocBeforeNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 1));
                var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
            }
            if (!isNDADoc) {
                docIds = docIds.replace(",AD", "");
            }
            else {
                if (sateDocBeforeAfterNDA)
                    docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }
        }
        else if (productId == 4) {
            if (!isPatentServices)
                docIds = this.isWestern ? docIds.replace(",125", "") : docIds.replace(",124", "");
            var addldoc = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
            if (addldoc)
                docIds = docIds.replace("AD", addldoc.id.toString());
            else
                docIds = docIds.replace(",AD", "");
        }
        if (this.isSecondContract) {
            docIds = docIds.replace(",3,", ",").replace(",4", "").replace(",1,", ",").replace(",38,", ",");
            if ((paymentOptionId == 1 || paymentOptionId == 0) && (countryID > 2) && productId == 4)
                docIds = docIds.replace("124,1", "124");
        }

        if (!isPayCollectForm)
            docIds = docIds.replace("35,", "");

        var waitstateDoc = this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == true);
        if (!isNullOrUndefined(state) && state.waitDays > 0)
            docIds = docIds.replace("W", waitstateDoc.id.toString());
        else
            docIds = docIds.replace(",W", "");

        if (!this.isStateExists) {
            if ((this.isSecondContract && paymentOptionId == 1) || (paymentOptionId == 0))
                docIds = docIds.replace(",0", "");
            else
                docIds = docIds.replace(",0,", ",");//.replace("S", "");
        }

        if (productId == 3 || productId == 7)
            this.finaldocument = "CheckList"
        else
            this.finaldocument = paymentOptionId == 2 ? "UPC" : this.isWaitStateExists ? "WaitDisc" : "ND";
        if (docIds.length > 2 && (productId == 1 || productId == 2)) {
            if (!isROIForm) {
                if (this.finaldocument == "UPC" || this.finaldocument == "WaitDisc"
                    || sateDocBeforeNDA || sateDocBeforeAfterNDA || (!isNullOrUndefined(state) && state.code == "KS"))
                    docIds = docIds.replace(",2,", ",");
                else {
                    if (isNDADoc) {
                        docIds = docIds.substring(0, docIds.length - 2);
                    }
                }
            }
        }
        if (isNullOrUndefined(this.printDocidAzure))
            this.printDocidAzure = [];
        this.printDocidAzure.push({ contractSessionId: contractSessionId, docId: docIds, statusCode: '0' });
    }
}
